module.exports = __webpack_public_path__ + "img/thumb_peanut.aac6be26.jpg";